//Create mapped type which converts all properties of type T recursively to be boolean or undefined.
export type BooleanOrUndefined<T> = {
  [P in keyof T]: T[P] extends infer U
    ? U extends object
      ? BooleanOrUndefined<U>
      : boolean | undefined
    : never;
};
